import { RegionCode } from "@/lib/axiosConfig";

export class SessionExpiredError extends Error {
  readonly regionCode: RegionCode;

  constructor(regionCode: RegionCode) {
    super(`Session expired for region ${regionCode}`);
    this.name = "SessionExpiredError";
    this.regionCode = regionCode;
  }
}

export class RegionInstancesFetchError extends Error {
  readonly regionCode: RegionCode;
  readonly status?: number;

  constructor(regionCode: RegionCode, status?: number, message?: string) {
    super(message ?? `Failed to fetch instances for region ${regionCode}`);
    this.name = "RegionInstancesFetchError";
    this.regionCode = regionCode;
    this.status = status;
  }
}
